(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("@vue/composition-api"));
	else if(typeof define === 'function' && define.amd)
		define([], factory);
	else if(typeof exports === 'object')
		exports["VueFlowEditor"] = factory(require("@vue/composition-api"));
	else
		root["VueFlowEditor"] = factory(root["vueCompositionApi"]);
})(this, function(__WEBPACK_EXTERNAL_MODULE__0__) {
return 